export default {
    setTableModal: (state, tableModal) => { state.tableModal = tableModal },
    setSelectedSection: (state, selectedSection) => { state.selectedSection = selectedSection },
    setTable: (state, table) => { state.table = table },
    setFinalTable: (state, finalTable) => { state.finalTable = finalTable },
    setManagementToken: (state, managementToken) => { state.managementToken = managementToken },
    setManagementUser: (state, managementUser) => { state.managementUser = managementUser },
    setItemId: (state, itemId) => { state.itemId = itemId },
    setPhotosModel: (state, photosModel) => { state.photosModel = photosModel },
    setProfile: (state, profile) => { state.profile = profile },
    setAlgorithm: (state, algorithm) => { state.algorithm = algorithm },
}